import { GET_LOGOUT_FAILURE, GET_LOGOUT_REQUESTED, GET_LOGOUT_SUCCESS } from "resources/actionTypes";

const intialState = {
    userLogout :[],
    loading: false,
    error: null,
};

export default function userLogout(state = intialState, action){
    switch(action.type){
        case GET_LOGOUT_REQUESTED:
         return {
            ...state,
            loading: true,
         };
        case GET_LOGOUT_SUCCESS:
            return {
                ...state,
                loading: true,
            };
        case GET_LOGOUT_FAILURE:
            return{
                ...state,
                loading: false,
                error:action.message,
            };
            default:
                return state;
    }
}